import { useCallback, useEffect, useState } from 'react';
import { isMac } from '@/shared/lib';

export type SpotlightTab = 'search' | 'navigate';

function useCmdK(open: () => void) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isCmdK =
        (isMac && e.metaKey && e.key.toLowerCase() === 'k') || (!isMac && e.ctrlKey && e.key.toLowerCase() === 'k');
      if (isCmdK) {
        e.preventDefault();
        open();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);
}

export function useSpotlight() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);

  useCmdK(toggle);

  return {
    isOpen,
    shortcut: isMac ? '⌘K' : 'ctrl+K',
    open,
    close,
    toggle,
  };
}
